/** ErrorBanner.tsx — error message with optional retry. */
import React from 'react';

interface Props {
	message: string;
	onRetry?: () => void;
}

export default function ErrorBanner({ message, onRetry }: Props) {
	return (
		<div className="err-banner" role="alert">
			<span>{message}</span>
			{onRetry && (
				<button type="button" onClick={onRetry}>
					Retry
				</button>
			)}
		</div>
	);
}
